import { useMemo } from "react";
import { Box, Button, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PhotoLibraryOutlinedIcon from "@mui/icons-material/PhotoLibraryOutlined";
import { useNavigate } from "react-router-dom";
import { GalleryArray } from "../../../../helpers/gallery";
import "./Highlights.css";

const bentoSpans = [
  "bento-item--hero",
  "bento-item--tall",
  "bento-item--tall",
  "bento-item--wide",
  "bento-item--standard",
  "bento-item--standard",
  "bento-item--standard",
  "bento-item--standard",
];

const HighlightImage = ({ src, index, onClick }) => (
  <Box
    className={`bento-item ${bentoSpans[index] || "bento-item--standard"}`}
    onClick={onClick}
    sx={{
      position: "relative",
      borderRadius: "16px",
      overflow: "hidden",
      cursor: "pointer",
      border: "1px solid rgba(255, 255, 255, 0.35)",
      boxShadow: "0 16px 40px rgba(0, 0, 0, 0.22)",
      // minHeight: { xs: "180px", sm: "200px" },
      "&:hover .highlight-image": {
        transform: "scale(1.06)",
      },
      "&:hover .highlight-overlay": {
        opacity: 1,
      },
    }}
  >
    <Box
      component="img"
      className="highlight-image"
      src={src}
      alt={`We Do Challenge highlight ${index + 1}`}
      loading="lazy"
      sx={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        display: "block",
        transition: "transform 0.5s ease",
      }}
    />
    <Box
      className="highlight-overlay"
      sx={{
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "linear-gradient(180deg, rgba(10, 14, 24, 0.05) 0%, rgba(10, 14, 24, 0.55) 100%)",
        opacity: { xs: 0.35, md: 0 },
        transition: "opacity 0.35s ease",
      }}
    >
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(255, 255, 255, 0.92)",
          color: "#23aef4",
          boxShadow: "0 8px 24px rgba(10, 14, 24, 0.15)",
        }}
      >
        <PhotoLibraryOutlinedIcon sx={{ fontSize: 22 }} />
      </Box>
    </Box>
  </Box>
);

const Highlights = () => {
  const navigate = useNavigate();

  const highlightImages = useMemo(
    () => [...GalleryArray].sort(() => 0.5 - Math.random()).slice(0, 8),
    []
  );

  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        position: "relative",
        overflow: "hidden",
        background:
          "linear-gradient(145deg, #9e1569 0%, #c11a83 45%, #a8176e 100%)",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          maxWidth: "1500px",
          margin: "0 auto",
          padding: { xs: "30px 20px", sm: "30px 60px", lg: "50px 120px" },
        }}
      >
        <Box sx={{ textAlign: "center", maxWidth: "680px", margin: "0 auto" }}>
          {/* <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              px: 1.75,
              py: 0.75,
              mb: 2,
              borderRadius: "999px",
              backgroundColor: "rgba(255, 255, 255, 0.12)",
              border: "1px solid rgba(255, 255, 255, 0.28)",
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "12px", md: "13px" },
                fontWeight: 700,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                color: "#fff",
              }}
            >
              Event Gallery
            </Typography>
          </Box> */}

          <Typography
            component="h2"
            sx={{
              color: "#fff",
              fontSize: { xs: "28px", sm: "34px", md: "42px" },
              lineHeight: 1.15,
              fontWeight: 800,
              letterSpacing: "-0.02em",
              mb: 2,
            }}
          >
            Championship Highlights
          </Typography>

          <Typography
            sx={{
              color: "rgba(255, 255, 255, 0.88)",
              lineHeight: 1.4,
              fontSize: { xs: "15px", md: "16px" },
              mb: 3,
            }}
          >
            Moments from past We Do Challenge events — teamwork, creativity,
            and competition day energy captured in photos.
          </Typography>

          <Button
            variant="contained"
            onClick={() => navigate("/gallery")}
            endIcon={<ArrowForwardIcon />}
            sx={{
              mb: { xs: 4, md: 5 },
              px: 2.5,
              py: 1.1,
              borderRadius: "999px",
              fontSize: "14px",
              fontWeight: 700,
              textTransform: "none",
              color: "#c11a83",
              backgroundColor: "#fff",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.18)",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.92)",
                boxShadow: "0 12px 32px rgba(0, 0, 0, 0.22)",
              },
            }}
          >
            View full gallery
          </Button>
        </Box>

        <Box className="highlights-bento">
          {highlightImages.map((src, i) => (
            <HighlightImage
              key={src}
              src={src}
              index={i}
              onClick={() => navigate("/gallery")}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Highlights;
